import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// import { getAuth } from 'firebase/auth';

export default class FirestoreService {
  static _firestore = null; // Static property to hold the Firestore instance
  static _storage = null;

  // Static method to initialize Firestore
  static async initialize() {
    try {
      // Fetch Firebase config from the remote function
      const response = await fetch('https://us-central1-joltchat.cloudfunctions.net/firebaseConfig');
      const configdata = await response.json();

      // Initialize Firestore with the configuration
      await FirestoreService._initializeFirestore(configdata);

    } catch (error) {
      console.error('Error initializing Firestore:', error);
      throw error;
    }
  }

  // Internal method to initialize Firestore
  static async _initializeFirestore(config) {
    const database = 'prod'; // Change this to 'dev' for development
    // const database = 'dev'; 

    // Initialize Firebase app
    const app = initializeApp(config);

    // Check if using dev database
    if (database === 'dev') {
      console.log('Running on Dev-Database');
      const db = getFirestore(app);
      db._databaseId.database = 'dev-joltchat';
      FirestoreService._firestore = db;
    } else {
      // Default to production database
      FirestoreService._firestore = getFirestore(app);
    }
    
    FirestoreService._storage = getStorage(app);

    // Enable offline persistence if available
    try {
      await FirestoreService._firestore.enablePersistence();
    } catch (err) {
      if (err.code === 'failed-precondition') {
        console.warn("Firestore persistence failed due to existing IndexedDB issue:", err);
      } else if (err.code === 'unimplemented') {
        console.warn("Firestore persistence is not available in this environment.");
      }
    }
  }

  // Static method to retrieve the Firestore instance
  static getFirestore() {
    if (!FirestoreService._firestore) {
      throw new Error('Firestore is not initialized. Call initialize() first.');
    }
    return FirestoreService._firestore;
  }

  static getStorage() {
    if (!FirestoreService._storage) {
      throw new Error('Storage is not initialized. Call initialize() first.');
    }
    return FirestoreService._storage;
  }

}